import { render, staticRenderFns } from "./LeftRegion.vue?vue&type=template&id=f8fa649c&scoped=true"
import script from "./LeftRegion.vue?vue&type=script&lang=js"
export * from "./LeftRegion.vue?vue&type=script&lang=js"
import style0 from "./LeftRegion.vue?vue&type=style&index=0&id=f8fa649c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_lodash@4.17.21_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@5.93.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fa649c",
  null
  
)

export default component.exports